export default function renderAdrSignatureV3(data) {
  return function (pdf) {
    let cursorY = this.cursorY;
    if (cursorY + 30 > this.maxY) {
      this._addPage(pdf);
      pdf
        .setFont("helvetica", "bold")
        .setFontSize(11)
        .text("This page left intentionally blank.", 302, 420, {
          align: "center",
        });
    }

    cursorY = 720;
    pdf.line(15, cursorY, 590, cursorY); // SigBlock Top
    pdf.line(206, cursorY, 206, cursorY + 30); // SigBlock mid-left
    pdf.line(397, cursorY, 397, cursorY + 30); // SigBlock mid-right
    cursorY += 10;
    pdf.setFont("helvetica", "normal").setFontSize(8);
    pdf.text("PRINT NAME", 18, cursorY);
    pdf.text("SIGNATURE", 209, cursorY);
    pdf.text("TITLE", 400, cursorY);
    pdf.setFont("times", "normal").setFontSize(10);
    pdf.text(data.authorFullName ? data.authorFullName : "", 18, cursorY + 14);
    this._setDefaults(pdf);
  };
}
